import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Page } from "../components/Page";
import { Title } from "../components/Title";
import { RouterButtonLink } from "../components/Button";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${spacing.x3}px;
  padding: ${spacing.x4}px;
`;

const NotFoundTitle = styled(Title)`
  font-size: 72px;
  font-weight: 700;
  color: ${colors.primary};
  margin: 0;
  line-height: 1;
`;

const NotFoundSubtitle = styled.h2`
  font-size: ${fontSizes.xlarge}px;
  font-weight: 600;
  color: ${colors.text};
  margin: 0;
`;

const NotFoundMessage = styled.p`
  font-size: ${fontSizes.regular}px;
  color: ${colors.textMuted};
  margin: 0;
  max-width: 500px;
`;

const ButtonContainer = styled.div`
  margin-top: ${spacing.x2}px;
`;

type NotFoundViewProps = {
  title?: string | false;
  subtitle?: string;
  message?: string | false;
  navbar?: React.ReactNode;
};

export const NotFoundView = ({
  title = "404",
  subtitle,
  message,
  navbar,
}: NotFoundViewProps = {}) => {
  const { t } = useTranslation();

  return (
    <Page centered fullHeight navbar={navbar}>
      <NotFoundContainer>
        {title !== false && <NotFoundTitle>{title}</NotFoundTitle>}
        <NotFoundSubtitle>{subtitle ?? t("notFound.subtitle")}</NotFoundSubtitle>
        {message !== false && (
          <NotFoundMessage>{message ?? t("notFound.message")}</NotFoundMessage>
        )}
        <ButtonContainer>
          <RouterButtonLink to="/">{t("notFound.goHome")}</RouterButtonLink>
        </ButtonContainer>
      </NotFoundContainer>
    </Page>
  );
};
